import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CardPrintFiltering } from './Pages';

export const CardPrintRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CardPrintFiltering} />
    </Fragment>
)